import { useSelector } from 'react-redux';
import { selectAgencies } from 'redux/selectors';
import { useActions } from 'hooks/redux/useActions';
import {
  setAgencies,
  setAgenciesIfEmpty,
  unsetAgencies,
} from 'redux/reducers/agencies-reducer';

export function useAgencies() {
  const { items: agencies, status: agenciesStatus } =
    useSelector(selectAgencies);
  const actions = useActions({
    setAgencies,
    unsetAgencies,
    setAgenciesIfEmpty,
  });

  return { agencies, agenciesStatus, ...actions };
}
